var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoCerrar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.625C8.7625 0.625 0.625 8.7625 0.625 19C0.625 29.2375 8.7625 37.375 19 37.375C29.2375 37.375 37.375 29.2375 37.375 19C37.375 8.7625 29.2375 0.625 19 0.625ZM26.0875 28.1875L19 21.1L11.9125 28.1875L9.8125 26.0875L16.9 19L9.8125 11.9125L11.9125 9.8125L19 16.9L26.0875 9.8125L28.1875 11.9125L21.1 19L28.1875 26.0875L26.0875 28.1875Z",
    fill: "#164453"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCerrar);
export default __webpack_public_path__ + "static/media/icono_cerrar.575949d4e32e792d67a750f255b57af8.svg";
export { ForwardRef as ReactComponent };